import React, { useState, useMemo } from "react";
import "./loginandsignup.css";
import { getDevice } from "./utils/deviceDetector";
import { useForm } from "react-hook-form";
import Spinner from "./components/LoadingSpinner";
import { signUp, logIn, resetPassword } from "./utils/firebaseUtils";

import Modal from "./components/Modal";

const LoginSignUp = () => {
  const [currentScreen, setCurrentScreen] = useState(0);

  const deviceType = useMemo(() => getDevice(), []); // Compute once and cache

  const currentYear = new Date().getFullYear();

  //  states for reset password
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [loading, setLoading] = useState(false);

  // for resetting password
  const [email, setEmail] = useState("");
  const [resetPasswordError, setResetPasswordError] = useState(null);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    if (currentScreen === 1) {
      try {
        const { email, password, confirmPassword } = data;
        if (password !== confirmPassword) {
          setError("root", { message: "Passwords do not match" });
          return;
        }
        // Call signUp function
        const { user, error } = await signUp(email, password);
        if (user) {
          console.log("✅ Signup successful:");
          return;
        } else if (error.includes("auth/email-already-in-use")) {
          setError("email", {
            message: "Email is already in use. Try logging in.",
          });
        } else {
          setError("root", { message: "Signup failed. Please try again." });
        }
      } catch (error) {
        setError("root", {
          message:
            "Error occurred! If error persists, contact rho1914scholarships@gmail.com",
        });
      }
    }

    if (currentScreen === 2) {
      try {
        const { email, password } = data;

        const { user, error } = await logIn(email, password);

        if (!user) {
          console.log("❌ Login error:", error);
          setError("root", { message: "Log in failed. Please try again." });
        }
      } catch (error) {
        console.error("❌ Unexpected error:", error);
        setError("root", {
          message:
            "Error occurred! If error persists, contact rho1914scholarships@gmail.com",
        });
      }
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    setResetPasswordError(null);
    setLoading(true);

    // Regular expression for validating email format
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (!email || !emailPattern.test(email)) {
      setResetPasswordError("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    const result = await resetPassword(email);

    if (!result.success) {
      setResetPasswordError("The email you've entered may be incorrect.");
    } else {
      closeModal();
    }

    setLoading(false);
  };

  const screens = [
    <div className="screen screen1">
      <div>
        <h2>
          {currentYear} O. Wilson <br className="force-break" /> Winters
          Memorial <br />
          Scholarship Program
        </h2>
      </div>

      <div>
        <span
          className="signup-btn"
          style={{
            paddingTop: deviceType === "iOS" ? "25px" : "auto",
            height: deviceType === "iOS" ? "25px" : "auto",
          }}
          onClick={() => setCurrentScreen(1)}
        >
          SIGN UP
        </span>
        <p
          style={{
            fontFamily: "gotham-light",
            color: "black",
            fontSize: "13px",
          }}
        >
          Already have an account?{" "}
          <span
            style={{
              fontFamily: "gotham-bold",
              cursor: "pointer",
              padding: "10px 0px",
            }}
            onClick={() => setCurrentScreen(2)}
          >
            Log in
          </span>
        </p>
      </div>
    </div>,
    <div className="screen screen2">
      <div>
        <h2>
          {currentYear} O. Wilson <br className="force-break" /> Winters
          Memorial <br />
          Scholarship Program
        </h2>
        <p
          style={{
            fontFamily: "gotham-light",
            color: "black",
            fontSize: "15px",
          }}
        >
          Already have an account?{" "}
          <span
            style={{
              fontFamily: "gotham-bold",
              cursor: "pointer",
              padding: "10px 0px",
            }}
            onClick={() => setCurrentScreen(2)}
          >
            Log in
          </span>
        </p>
      </div>
      <div>
        <form className="sign-up-form" onSubmit={handleSubmit(onSubmit)}>
          {/* email */}
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              {...register("email", {
                required: "Email is required",
                pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
              })}
              type="email"
              id="email"
              name="email"
              placeholder="myemail@gmail.com"
            />
            {errors.email && (
              <p className="error-message">{errors.email.message}</p>
            )}
          </div>

          {/* password */}
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 8,
                  message: "Password must be at least 6 characters",
                },
                maxLength: { value: 20, message: "Password is too long" },
              })}
              type="password"
              id="password"
              name="password"
              placeholder="******"
            />
            {errors.password && (
              <p className="error-message">{errors.password.message}</p>
            )}
          </div>

          {/* confirm password */}
          <div className="input-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              {...register("confirmPassword", {
                required:
                  currentScreen === 1 ? "Please confirm your password" : false,
                minLength: {
                  value: 8,
                  message: "Password must be at least 6 characters",
                },
                maxLength: { value: 20, message: "Password is too long" },
              })}
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              placeholder="******"
            />
            {errors.confirmPassword && (
              <p className="error-message">{errors.confirmPassword.message}</p>
            )}
          </div>

          {errors.root && (
            <p className="error-message">{errors?.root?.message}</p>
          )}

          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? <Spinner /> : "Sign Up"}
          </button>
        </form>
      </div>
    </div>,
    <div className="screen screen3">
      <div>
        <h2>
          {currentYear} O. Wilson <br className="force-break" /> Winters
          Memorial <br />
          Scholarship Program
        </h2>
        <p
          style={{
            fontFamily: "gotham-light",
            color: "black",
            fontSize: "15px",
          }}
        >
          Don't have an account?{" "}
          <span
            style={{
              fontFamily: "gotham-bold",
              cursor: "pointer",
              padding: "10px 0px",
            }}
            onClick={() => setCurrentScreen(1)}
          >
            Sign up
          </span>
        </p>
      </div>
      <div>
        <form className="log-in-form" onSubmit={handleSubmit(onSubmit)}>
          {/* email */}
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              {...register("email", {
                required: "Email is required",
                pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
              })}
              type="email"
              id="email"
              name="email"
              placeholder="myemail@gmail.com"
            />
            {errors.email && (
              <p className="error-message">{errors.email.message}</p>
            )}
          </div>

          {/* password */}
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 8,
                  message: "Password must be at least 8 characters",
                },
                maxLength: { value: 20, message: "Password is too long" },
              })}
              type="password"
              id="password"
              name="password"
              placeholder="******"
            />
            {errors.password && (
              <p className="error-message">{errors.password.message}</p>
            )}
          </div>
          {true && <p className="error-message">{errors?.root?.message}</p>}

          <p
            style={{
              fontFamily: "gotham-light",
              color: "black",
              fontSize: "10px",
            }}
          >
            Forgot password?{" "}
            <span
              style={{
                fontFamily: "gotham-bold",
                cursor: "pointer",
                padding: "10px 0px",
              }}
              onClick={openModal}
            >
              Reset now
            </span>
          </p>
          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? <Spinner /> : "Log in"}
          </button>
        </form>
      </div>
    </div>,
  ];

  return (
    <div className="scroll-container">
      <div className="screen-content">{screens[currentScreen]}</div>
      {/* user is requesting password reset */}
      <Modal isOpen={isModalOpen} onRequestClose={closeModal}>
        <h2>A password reset link will be sent to the email below</h2>

        <div className="input-group reset-password-input">
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="btns">
          <span
            style={{
              paddingTop: deviceType === "iOS" ? "25px" : null,
              height: deviceType === "iOS" ? "5px" : null,
            }}
            className="primary-btn"
            onClick={handleResetPassword}
          >
            {loading ? "Sending link..." : "Send link"}
          </span>
          <span
            style={{
              paddingTop: deviceType === "iOS" ? "25px" : null,
              height: deviceType === "iOS" ? "5px" : null,
            }}
            className="primary-btn"
            onClick={closeModal}
          >
            <p style={{ color: "#333" }}> Cancel</p>
          </span>
        </div>
        {resetPasswordError && (
          <p className="error-message">{resetPasswordError}</p>
        )}
      </Modal>
    </div>
  );
};

export default LoginSignUp;
